import { Size } from '../Size';
import { Position } from '../Transform/Position';
import { Rotation } from '../Transform/Rotation';
import { Scale } from '../Transform/Scale';
import { GraphicElement } from './GraphicElement';
import { Group } from './Group';
export class BackPattern extends Group {
    constructor(
        engine,
        content,
        pos = new Position(),
        uuid = GraphicElement.generateUUID(),
        size = new Size(),
        options = {},
        scale = new Scale(),
        rotation = new Rotation()
    ) {
        // shouldBeConstrained=false (dernier arg) : le Transform NE DOIT PAS appliquer
        // ses contraintes pixel, et ce DÈS son constructeur (sinon trop tard). Le
        // BackPattern est un fond couvrant à coords NORMALISÉES (fraction 0-1) épousant
        // sa zone. Sur une zone à `left` négatif, `pos.x < 0` déclenchait
        // `pos.x += widthCanvas` (1024) → la fraction -0.0031 devenait 1023.99 → le
        // motif partait à ~1M px hors zone (invisible en 2D ET 3D). Régler le flag
        // APRÈS super() ne suffisait pas : le wrap avait déjà eu lieu dans le ctor.
        super(engine, uuid, pos, size, options, scale, rotation, false);
        this.type = 'BackPattern';
        this._content = content;
        this.isDuplicated = false;
        this.transform.isMovable = false;
        // Ceinture + bretelles : garantit qu'aucun moveTo/reload ultérieur ne
        // réintroduise le wrap sur ce fond non déplaçable.
        this.transform.shouldApplyConstraints = false;
    }
    get canBeUnlocked() {
        return false;
    }
    set canBeUnlocked(canBeUnlocked) {
        this._canBeUnlocked = false;
    }
    get canBeSelected() {
        return false;
    }
    get isLocked() {
        return true;
    }
    static hydrate(data) {
        const backPattern = new BackPattern(
            data._engine,
            data._content,
            new Position(data.transform._pos._x, data.transform._pos._y),
            data._uuid,
            new Size(data.originSize._width, data.originSize._height)
        );
        backPattern.transform.resize(new Scale(data.transform._scale._scaleX, data.transform._scale._scaleY), true);
        backPattern.transform.rotate(data.transform._rotation._angle, true);
        backPattern.colorGroups = data._colorGroups;
        backPattern.options = data.options;
        backPattern.visible = data.visible;
        return backPattern;
    }
}
